import React, { useContext, useEffect, useState } from 'react';
import { useLazyQuery, useQuery } from '@apollo/client';
import { fetchDimensions, getAttributeTypes } from 'gqlQueries/filterQueries';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { client } from 'services/apolloInit';

const errorMessage: string = 'Something went wrong!';

interface AttributeParams {
    startTimestamp: number;
    endTimestamp: number;
    frequency: string;
    filters: string;
    attributeType: string;
    isAttribute: boolean;
    offset: number;
    limit: number;
}

function useFetchAllDimAndAttributeTypes({ currentScreenFeatureName }: { currentScreenFeatureName: string }) {
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>({});
    const { appConfig } = useContext(UserContext);
    const filterConfig = getConfig('globalFilter', appConfig);
    const commonConfig = getConfig('commonConfig', appConfig);
    const handleDim2SortingFromFrontend = commonConfig?.handleDim2SortingFromFrontend || false;

    //To fetch dim
    const [fetchDim, { data: dimentionList, loading: dimentionLoading, error: dimentionError }] = useLazyQuery(
        fetchDimensions,
        { onCompleted: onComplete },
    );

    //setting states to default on calling api
    function callAllAttributeType(variables: any) {
        setLoading(true);
        setData({});
        setError(null);
        fetchDim({ variables });
    }

    function onComplete(payload: any) {
        const { getDimensionList = [] } = payload;
        if (getDimensionList?.length) {
            setData((oldData: any) => ({
                ...oldData,
                ['dimention']: getDimensionList,
            }));
            //dynamically calling attributes types for all dimensions
            if (getDimensionList && Array.isArray(getDimensionList)) {
                getDimensionList?.map((dimensionItem: any) => {
                    client
                        .query({
                            query: getAttributeTypes,
                            variables: {
                                dimension: dimensionItem?.dimensionReference,
                                hierarchy: dimensionItem?.dimensionName,
                                featureName: currentScreenFeatureName,
                            },
                            fetchPolicy: 'cache-first',
                        })
                        .then((question: any) => {
                            let data = question?.data?.getAttributeTypes?.map((item: any) => {
                                return {
                                    ...item,
                                    dimensionReference: dimensionItem?.dimensionReference,
                                    dimensionName: dimensionItem?.dimensionName,
                                };
                            });

                            //sorting for perrigo
                            if (handleDim2SortingFromFrontend && dimensionItem?.dimensionReference === 'dim2') {
                                data.reverse();
                            }
                            setData((oldData: any) => ({ ...oldData, [dimensionItem?.dimensionReference]: data }));
                        })
                        .catch((err: any) => {
                            setError(err);
                            setLoading(false);
                        });
                });
            }
        }
    }

    return {
        loading,
        setLoading,
        error: error || dimentionError,
        data,
        callAllAttributeType,
    };
}

export default useFetchAllDimAndAttributeTypes;
